import { FormTemplatesModel as Model } from './Model'


export const MODULE_NAME = 'form-templates'

export const FORM_TEMPLATE_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  EDIT: `${MODULE_NAME}.edit`,
  VIEW: `${MODULE_NAME}.view`,
  CREATE: `${MODULE_NAME}.create`,

  PROFILE: `${MODULE_NAME}.profile`,
} as const

export const MENU = {
  id: FORM_TEMPLATE_ROUTES.LAYOUT,
  route: { name: FORM_TEMPLATE_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-form-select',
} as const

export const getUuid = () => import(
  /* webpackChunkName: "nanoid" */
  'nanoid'
).then((_) => _.nanoid(10))
